import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next';

import { mainContext } from '../../../MainContext';
import FadeinWrap from '../../../../common/animation/FadeinWrap';


function ContainerShidou() {
  const { t } = useTranslation();

  const getLink = useContext(mainContext).getLink;

  useEffect(() => {
  }, [])


  return (
    <div className="ms-auto me-auto text-center">
      <FadeinWrap>
        <img src={t('shidou')} className="object-fit-cover w-100 w-md-75" alt="無料特典で得られる６つの未来" />
      </FadeinWrap>
    </div>
  );
}

export default ContainerShidou;